import { z } from 'zod'
import { EngagementOptionEnumValues, MarketMakerEngagementsStatusEnumValues } from '@forgd/shared/enums'
import { MarketMakerSchema } from '../market-maker'

// Engagement Schema
const EngagementSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  qtyTokensLoan: z.number().safe(),
  qtyTokensWorkingCapital: z.number().safe(),
  qtyStablesWorkingCapital: z.number().safe(),
  bidAskSpreadTarget: z.number().safe().nullable(),
  depth50Target: z.number().safe().nullable(),
  depth100Target: z.number().safe().nullable(),
  depth200Target: z.number().safe().nullable(),
  uptimeSpread: z.number().safe().nullable(),
  uptimeBidAskDepth50: z.number().safe().nullable(),
  uptimeBidAskDepth100: z.number().safe().nullable(),
  uptimeBidAskDepth200: z.number().safe().nullable(),
  marketMakerId: z.string(),
  status: z.enum(MarketMakerEngagementsStatusEnumValues),
  type: z.enum(EngagementOptionEnumValues),
  importName: z.string().nullable(),
})

// Get Engagements
export const GetEngagementsResult = z.array(
  EngagementSchema.extend({
    marketMaker: MarketMakerSchema,
  }),
)
export type GetEngagementsResultType = z.infer<typeof GetEngagementsResult>
